module.exports = __webpack_public_path__ + "static/media/MuseoSansBold.2f1535ec.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/static/fonts/MuseoSansBold/MuseoSansBold.ttf
// module id = 639
// module chunks = 0